import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { moneyUnit as _moneyUnit } from "../js/utils";
import countTo from 'vue-count-to';
export default {
  props: {
    vData: {
      type: Object,
      default: function _default() {
        return {
          sum: 0
        };
      }
    },
    queryType: {
      type: String | Number
    }
  },
  watch: {
    vData: function vData(val) {}
  },
  components: {
    countTo: countTo
  },
  data: function data() {
    return {
      option: null,
      moneyData: {
        money: 0,
        unit: '元'
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    moneyUnit: function moneyUnit(money) {
      return _moneyUnit(money).unit;
    },
    moneyMounted: function moneyMounted(money) {
      var moneyVal = _moneyUnit(money).money;
      return Number(moneyVal);
    }
  },
  beforeDestroy: function beforeDestroy() {}
};